module.exports = __webpack_public_path__ + "static/img/epmty-list.e7fd33ae.png";